<mat-form-field appearance="fill">
  <mat-label>Shipping Tags</mat-label>
  <mat-select (selectionChange)="changeTag($event)" [(value)]="selected._id">
    <mat-option *ngFor="let tag of shippingTags" [value]="tag._id">
      {{tag.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
